const people = [
  {
    id: 1,
  
    name: "शरद उबाळे",
    // title: "manager",
    quote:
      "खूप चांगली जागा चिकन थाळी आणि खास चिकन खर्डा स्वादिष्ट आहे. उत्तम सेवा  व स्वयंपाकघर आहे."
  },
  {
    id: 2,
 
    name: "रोशन पवार",
    //title: "Project Manager",
    quote:
      "या हॉटेलमध्ये उत्कृष्ट नॉन व्हेज आहे आणि माझं अनुभव खूप छान आहे .  ",
  },
  {
    id: 3,
  
    name: "सतीश सोनवणे",
    //  title: "Product Manager",
    quote:
      "एक नंबर जागा आणि संपूर्ण पैसे वसूल,नॉनव्हेज खवय्यांसाठी एक नंबर जागा",
  },
  {
    id: 4,
   
    name: "राम पाटील",
    // title: "Vice President",
    quote:
      "सर्व स्टाफची उत्कृष्ट सेवा आहे आणि हॉटेल नेचरली पोशिंग आणि स्वच्छता खूपच आवडली. माझ्याकडून हा मी सर्वांना हा हॉटेल अगदी शिफारस करतो.",
  },
];

export default people;
